import { createEffect } from "effector"
import { lastValueFrom } from "rxjs"
import { HttpService } from "@callcenter/services"

import type { StartKycResponse } from "../shared/types"

export const requestUpgradeFx = createEffect(() =>
  lastValueFrom(HttpService.post<StartKycResponse, Record<string, never>>("/self_service_trials/upgrade_now", {}))
)

export const startKycFx = createEffect(() =>
  lastValueFrom(HttpService.post<StartKycResponse, Record<string, never>>("/shuftipro_kyc_attempts.json", {}))
)

export const sendVerificationEmailFx = createEffect(() =>
  lastValueFrom(HttpService.post<void, Record<string, never>>("/self_service_trials/send_verification_email", {}))
)

export const redirectToKycFx = createEffect<string, void>((url) => {
  window.location.href = url
})

type SelfServiceMessage = {
  days: { total: number; left: number }
  shouldOpenTrialPreview: boolean
  shouldOpenTrialSupportChat: boolean
  shouldOpenTrialHome: boolean
  disableUpgradeButton: boolean
}

const DEFAULT_TRIAL_SETTINGS = {
  days: { total: 0, left: 0 },
  shouldOpenTrialPreview: false,
  shouldOpenTrialSupportChat: false,
  shouldOpenTrialHome: false,
  disableUpgradeButton: false
}

const MAX_TRIES_TO_DETECT_WEBCHAT = 5

export const startSetupFx = createEffect<SelfServiceMessage, void>((settings) => {
  const checkAndSendMessage = (attempt: number): void => {
    const webchatIframe = document.getElementById("webchat") as HTMLIFrameElement | null

    if (webchatIframe) {
      webchatIframe.contentWindow?.postMessage({
        webchatSettings: { mode: "trial" },
        trialSettings: {
          ...DEFAULT_TRIAL_SETTINGS,
          ...settings
        }
      })
    } else if (attempt <= MAX_TRIES_TO_DETECT_WEBCHAT) {
      setTimeout(() => checkAndSendMessage(attempt + 1), 1000)
    }
  }

  checkAndSendMessage(1)
})
